import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';

import Avatar from 'uikit/Avatar';
import Menu, { MenuItem } from 'uikit/Menu';

import styles from './AccountMenu.module.scss';

const cx = classNames.bind(styles);

const AccountMenu = ({ className, isGAR, isInTeams, me, t }) => (
  <div className={className}>
    <Menu
      placement="bottom-end"
      toggle={
        <button
          aria-label={t('Shared/MenuContainer/AccountMenu/aria-my-account')}
          className={cx('toggle')}
          data-testid="settings-button"
          type="button"
        >
          <Avatar profile={me} />
          <span className={cx('name')}>{me.firstName}</span>
        </button>
      }
    >
      <MenuItem as={Link} icon="cog" to="/settings">
        {t('Shared/MenuContainer/AccountMenu/settings')}
      </MenuItem>
      {!isInTeams && !isGAR && (
        <MenuItem as={Link} icon="rocket-launch" to="/subscription">
          {t('Shared/MenuContainer/AccountMenu/subscription')}
        </MenuItem>
      )}
      <MenuItem
        as={Link}
        data-testid="logout-button"
        icon="sign-out"
        to="/auth/logout"
      >
        {t('Shared/MenuContainer/AccountMenu/sign-out')}
      </MenuItem>
    </Menu>
  </div>
);

AccountMenu.propTypes = {
  className: PropTypes.string,
  isGAR: PropTypes.bool.isRequired,
  isInTeams: PropTypes.bool.isRequired,
  me: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
};

AccountMenu.defaultProps = {
  className: undefined,
};

export default AccountMenu;
